import React from "react"
import { Link } from "react-router-dom"
import logo from "../../assets/images/examcreator.png"
import { STUDENT_DASHBOARD_PATH } from "./config/studentNavItems"
import { useGuardLinkClick } from "./unsavedChangesGate"
import "./StudentLogo.style.scss"

export type StudentLogoSize = "sm" | "md" | "lg"

interface StudentLogoProps {
  size?: StudentLogoSize
  collapsed?: boolean
  className?: string
}

const StudentLogo = ({
  size = "md",
  collapsed = false,
  className = "",
}: StudentLogoProps) => {
  const onClick = useGuardLinkClick(STUDENT_DASHBOARD_PATH)

  return (
    <Link
      to={STUDENT_DASHBOARD_PATH}
      className={`student-logo student-logo--${size} ${
        collapsed ? "student-logo--collapsed" : ""
      } ${className}`.trim()}
      aria-label="Exam Creator home"
      onClick={onClick}
    >
      <img src={logo} alt="ExamCreator Logo" />
    </Link>
  )
}

export default StudentLogo
